angular.module 'app'
.controller 'TemplateLayout2Ctrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
